import Moment from 'moment';

export function dateWithNoTimezone(isostring) {
    var date = new Date(Moment.parseZone(isostring).utc().format())
    var userTimezoneOffset = date.getTimezoneOffset() * 60000;

    return new Date(date.getTime() + userTimezoneOffset);
}